import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import { Logger } from 'simple-logging-lib';
import { CROSS_TAB_LINK_LOGGER_NAME } from '../../config/constants';
import { CrossTabLinkError } from '../../errors';
import { Subject } from 'reactive-lib/observable/subject';
import { getWindow } from '../../utils';
import { linkOperations } from './operations';
const BROADCAST_KEY_PREFIX = '@@magpie/cross-tab-link';
var _instance = /*#__PURE__*/_classPrivateFieldLooseKey("instance");
var _events = /*#__PURE__*/_classPrivateFieldLooseKey("events");
var _subscription = /*#__PURE__*/_classPrivateFieldLooseKey("subscription");
var _messageLinkSubscription = /*#__PURE__*/_classPrivateFieldLooseKey("messageLinkSubscription");
export class CrossTabLink {
  constructor() {
    Object.defineProperty(this, _events, {
      writable: true,
      value: new Subject()
    });
    Object.defineProperty(this, _subscription, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _messageLinkSubscription, {
      writable: true,
      value: void 0
    });
    this.logger = Logger.getLogger(CROSS_TAB_LINK_LOGGER_NAME);
    this.options = null;
    this.broadcast = (operation, clientId) => {
      const broadcastKey = this.getBroadcastKey(clientId);
      try {
        getWindow().localStorage.setItem(broadcastKey, JSON.stringify(operation));
        getWindow().localStorage.removeItem(broadcastKey);
      } catch (e) {
        throw new CrossTabLinkError(CrossTabLinkError.Reason.LOCAL_STORAGE_ERROR);
      }
    };
    this.connect = options => {
      this.options = options;
      getWindow().addEventListener('storage', this.onStorageEvent);
      const events$ = _classPrivateFieldLooseBase(this, _events)[_events].asObservable();
      _classPrivateFieldLooseBase(this, _subscription)[_subscription] = events$.subscribe(this.onLinkOperation);
      _classPrivateFieldLooseBase(this, _messageLinkSubscription)[_messageLinkSubscription] = this.getOptions().messageLink.asObservable().subscribe(this.onMessage);
      return events$;
    };
    this.disconnect = () => {
      var _classPrivateFieldLoo, _classPrivateFieldLoo2;
      getWindow().removeEventListener('storage', this.onStorageEvent);
      _classPrivateFieldLooseBase(this, _events)[_events].complete();
      (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _subscription)[_subscription]) === null || _classPrivateFieldLoo === void 0 || _classPrivateFieldLoo.unsubscribe();
      (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _messageLinkSubscription)[_messageLinkSubscription]) === null || _classPrivateFieldLoo2 === void 0 || _classPrivateFieldLoo2.unsubscribe();
    };
    this.getOptions = () => {
      if (!this.options) {
        throw new CrossTabLinkError(CrossTabLinkError.Reason.NOT_CONNECTED);
      }
      return this.options;
    };
    this.onStorageEvent = ({
      key,
      newValue
    }) => {
      if (key !== null && key !== void 0 && key.startsWith(BROADCAST_KEY_PREFIX) && newValue) {
        this.logger.debug('X-Tab Link Storage Event', key, newValue);
        try {
          _classPrivateFieldLooseBase(this, _events)[_events].next(JSON.parse(newValue));
        } catch (e) {
          this.logger.error('Failed to parse storage event', e);
        }
      }
    };
    this.onMessage = message => {
      if (message.senderBrokerId !== this.getOptions().brokerId) {
        return;
      }
      if (message.allowCrossTab) {
        this.logger.debug('Broadcasting message via x-tab link', message);
        this.broadcast(linkOperations.sendMessage(message), message.sender);
      }
    };
    this.onLinkOperation = operation => {
      this.logger.info('Received x-tab link operation', operation);
      if (linkOperations.sendMessage.match(operation)) {
        this.getOptions().messageLink.next(operation.payload);
      }
    };
  }
  static getInstance() {
    if (!_classPrivateFieldLooseBase(CrossTabLink, _instance)[_instance]) {
      _classPrivateFieldLooseBase(CrossTabLink, _instance)[_instance] = new CrossTabLink();
    }
    return _classPrivateFieldLooseBase(CrossTabLink, _instance)[_instance];
  }
  getBroadcastKey(clientId) {
    return `${BROADCAST_KEY_PREFIX}/${clientId}`;
  }
}
Object.defineProperty(CrossTabLink, _instance, {
  writable: true,
  value: void 0
});